import React, { useState ,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import './PlanDetail.css';
import { initFacebookPixel } from '../facebookPixel';
const plans = [
  {
    "name": "1 Month Plan",
    "originalPrice": 9000,
    "discountedPrice": 4900,
    "reasons": [
      "Swim for 30 hours in a Month at any Machaxi Centre",
      "Book up to 2 time slots every day",
      "Earn reward points up-to 5 in one hour of playing",
      "Hassle-free slot bookings",
      "Book for yourself or come with your guests and keep the game going!",
      "Cancel your slot 3 hours before the booking time",
      "Applicable only for 18+ age group"
    ],
    "bestSeller": false
  },  
  {
    "name": "3 Months Plan",
    "originalPrice":  20000   ,
    "discountedPrice": 5039,
    "reasons": [
      "Swim for 90 hours in a Quarter at any Machaxi Centre",
      "Book up to 2 time slots every day",
      "Earn reward points up-to 5 in one hour of playing",
      "Hassle-free slot bookings",
      "Book for yourself or come with your guests and keep the game going!",
      "Cancel your slot 3 hours before the booking time",
      "Applicable only for 18+ age group"
    ],

    "bestSeller": false
  },  
  {
    "name": "6 Months Plan",
    "originalPrice": 35000
    ,
    "discountedPrice": 8260,
    "reasons": [
      "Swim for 180 hours in a Half-year at any Machaxi Centre",
      "Book up to 2 time slots every day",
      "Earn reward points up-to 5 in one hour of playing",
      "Hassle-free slot bookings",
      "Book for yourself or come with your guests and keep the game going!",
      "Cancel your slot 3 hours before the booking time",
      "Applicable only for 18+ age group"
    ],

    "bestSeller": false
  }, 
  {
    "name": "12 Months Plan",
    "originalPrice": 50000,
    "discountedPrice": 12399,
    "reasons": [
      "Swim for 365 hours in a Year at any Machaxi Centre",
      "Book up to 2 time slots every day",
      "Earn reward points up-to 5 in one hour of playing",
      "Hassle-free slot bookings",
      "Book for yourself or come with your guests and keep the game going!",
      "Cancel your slot 3 hours before the booking time",
      "Applicable only for 18+ age group"
    ],

    "bestSeller": false
  }, 
];


const PlanDetail = () => {
  const navigate = useNavigate();
  const [expandedPlans, setExpandedPlans] = useState(
    new Array(plans.length).fill(false)
  );

  const handleSeeMore = (event, index) => {
    event.stopPropagation(); // Prevents navigation when clicking "See More"
    const updatedExpandedPlans = [...expandedPlans];
    updatedExpandedPlans[index] = !updatedExpandedPlans[index];
    setExpandedPlans(updatedExpandedPlans);
  };
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);

  const handleBookTrial = () => {
    window.location.href = '/book-trial';
  };
  return (
    <div className="plan-detail-container">
      <div className="plan-title">Plan Details</div>

      {plans.map((plan, index) => (
        <div
          className="plan-card"
          key={index}
          onClick={handleBookTrial} // Navigate when clicking on the container
        >
          {plan.bestSeller && <div className="best-seller-badge">Best Seller</div>}

          <div className="plan-body">
            <div className="plan-left">
              <div className="plan-header">
                <h3>{plan.name}</h3>
              </div>
              <div className="plan-info">
                <ul>
                  {plan.reasons.slice(0, 2).map((reason, i) => (
                    <li key={i}>{reason}</li>
                  ))}
                  {plan.reasons.length > 2 && !expandedPlans[index] && (
                    <li>
                      <button
                        className="see-more"
                        onClick={(event) => handleSeeMore(event, index)}
                      >
                        See More
                      </button>
                    </li>
                  )}
                  {expandedPlans[index] &&
                    plan.reasons.slice(2).map((reason, i) => (
                      <li key={i}>{reason}</li>
                    ))}
                </ul>
              </div>
            </div>
            <div className="divider-line"></div>

            <div className="plan-right">
              <p className="discounted-price">₹{plan.discountedPrice}</p>
              <p className="original-price">₹{plan.originalPrice}</p>
            </div>
          </div>
        </div>
      ))}
      
    </div>
  );
};

export default PlanDetail;
